export const getAccessToken = () => localStorage.getItem("token");
